module.exports = __webpack_public_path__ + "static/img/winner_top.eeedaee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winner_top.png
// module id = RWa3
// module chunks = 1